import BigNumber from "bignumber.js";
import { BigNumber as BN, providers, utils } from "ethers";
import { decimalRecords } from "./decimals";
import { Address } from "./types";

export function formatObject(object: Object) {
  return JSON.stringify(object, null, '  ');
}

export function decimalFactor(decimal: number) {
  return BN.from(10).pow(decimal).toString();
}

export const isSameAddress = (address1: Address, address2: Address): boolean => {
  return address1.toLowerCase() == address2.toLowerCase()
}

export const getCurrentTimestamp = async (provider: providers.Provider): Promise<number> => {
  // const latestBlockNumber = await provider.getBlockNumber();
  // const currentTime: number = (await provider.getBlock(latestBlockNumber)).timestamp;
  // return currentTime;
  return Math.trunc(Date.now() / 1000)
}

export function validateAndParseAddress(address: Address): Address {
  try {
    return utils.getAddress(address);
  } catch (error) {
    throw new Error("Invalid address: " + address);
  }
}

export function getDecimal(address: Address): number {
  return decimalRecords[address.toLowerCase()];
}
export function calcLMRewardApr(rewardsValue: BigNumber, totalStakeValue: BigNumber, frequencyPerYear: number): BigNumber {
  if (totalStakeValue.lte(0)) { // avoid division by zero when there is no stake
      return new BigNumber('999999999');
  }
  return rewardsValue.multipliedBy(frequencyPerYear).dividedBy(totalStakeValue);
}
